import { Metric } from "@/metrics/installationMetrics";

export type LineChartResponse = {
  xAxis: any;
  yAxis: any;
  series: Series[];
  legend: {
    data: string[];
    unit?: Metric["unit"];
  }
  datums: Record<string, SeriesDatum[]>;
  overrides?: {
    chart_type: string;
    chart_title: string;
    chart_unit: string;
  }
}

export type Series = {
  data: [string, number][],
  yAxisIndex?: number;
  type: string;
  name: string;
  lineStyle: any
}

export enum SeriesDatumName {
  AVERAGE = "Average",
  MAXIMUM = "Maximum",
  MINIMUM = "Minimum",
  LATEST = "latest",
  SUM = "sum",
  TREND = "trend"
}

export type SeriesDatum = {
  datum: number;
  name: SeriesDatumName | string;
}

export const getDatum = (seriesName: "overall" | string, datumName: SeriesDatum["name"]) => (res?: LineChartResponse): SeriesDatum => {
  return res?.datums[seriesName]?.find((datum) => datum.name == datumName);
}

export const trimLineChartResponsesByTime = (
  responses: LineChartResponse[],
  startTime: number,
  endTime: number
): LineChartResponse[] => {
  return responses.map(response => ({
    ...response,
    series: response.series.map(series => ({
      ...series,
      data: series.data.filter(([timestamp, _value]) => {
        const time = new Date(timestamp).getTime();
        return time >= startTime && time <= endTime;
      })
    }))
  }));
};

export const getEarliestTimestamp = (responses: LineChartResponse[]): number => {
  const timestamps = responses
    .flatMap(r => r.series)
    .flatMap(s => s.data)
    .map(([ts]) => new Date(ts).getTime())
    .filter(time => !isNaN(time)); // filter out invalid dates if needed

  return Math.min(...timestamps);
};

export const getLatestTimestamp = (responses: LineChartResponse[]): number => {
  const timestamps = responses
    .flatMap(r => r.series)
    .flatMap(s => s.data)
    .map(([ts]) => new Date(ts).getTime())
    .filter(time => !isNaN(time));

  return Math.max(...timestamps);
};
